var map = {
	"./": [
		2812,
		9
	],
	"./App.bs": [
		4986,
		9
	],
	"./App.bs.js": [
		4986,
		9
	],
	"./App.res": [
		3581,
		1,
		3581
	],
	"./AppContext.bs": [
		9115,
		9
	],
	"./AppContext.bs.js": [
		9115,
		9
	],
	"./AppContext.res": [
		6870,
		1,
		6870
	],
	"./Css.bs": [
		7158,
		9
	],
	"./Css.bs.js": [
		7158,
		9
	],
	"./Css.res": [
		9809,
		1,
		9809
	],
	"./Index.bs": [
		1839,
		9
	],
	"./Index.bs.js": [
		1839,
		9
	],
	"./Index.res": [
		4568,
		1,
		4568
	],
	"./Translation.bs": [
		6490,
		9
	],
	"./Translation.bs.js": [
		6490,
		9
	],
	"./Translation.res": [
		5269,
		1,
		5269
	],
	"./blocks/Body.bs": [
		3958,
		9
	],
	"./blocks/Body.bs.js": [
		3958,
		9
	],
	"./blocks/Body.res": [
		610,
		1,
		8229
	],
	"./blocks/Footer.bs": [
		2731,
		9
	],
	"./blocks/Footer.bs.js": [
		2731,
		9
	],
	"./blocks/Footer.res": [
		4884,
		1,
		4884
	],
	"./blocks/Header.bs": [
		2505,
		9
	],
	"./blocks/Header.bs.js": [
		2505,
		9
	],
	"./blocks/Header.res": [
		9966,
		1,
		9966
	],
	"./blocks/Sidebar.bs": [
		4038,
		9
	],
	"./blocks/Sidebar.bs.js": [
		4038,
		9
	],
	"./blocks/Sidebar.res": [
		9727,
		1,
		9727
	],
	"./blocks/Template.bs": [
		8168,
		9,
		8168
	],
	"./blocks/Template.bs.js": [
		8168,
		9,
		8168
	],
	"./blocks/Template.res": [
		8347,
		1,
		8347
	],
	"./components/ArticleItem.bs": [
		6307,
		9
	],
	"./components/ArticleItem.bs.js": [
		6307,
		9
	],
	"./components/ArticleItem.res": [
		818,
		1,
		818
	],
	"./components/ArticleLoading.bs": [
		3922,
		9
	],
	"./components/ArticleLoading.bs.js": [
		3922,
		9
	],
	"./components/ArticleLoading.res": [
		7809,
		1,
		7809
	],
	"./components/Author.bs": [
		421,
		9
	],
	"./components/Author.bs.js": [
		421,
		9
	],
	"./components/Author.res": [
		2734,
		1,
		2734
	],
	"./components/Flag.bs": [
		7594,
		9
	],
	"./components/Flag.bs.js": [
		7594,
		9
	],
	"./components/Flag.res": [
		5597,
		1,
		5597
	],
	"./components/LanguageSelector.bs": [
		4165,
		9
	],
	"./components/LanguageSelector.bs.js": [
		4165,
		9
	],
	"./components/LanguageSelector.res": [
		6362,
		1,
		6362
	],
	"./components/LargeProjectItem.bs": [
		6165,
		9
	],
	"./components/LargeProjectItem.bs.js": [
		6165,
		9
	],
	"./components/LargeProjectItem.res": [
		6658,
		1,
		6658
	],
	"./components/Logo.bs": [
		8629,
		9
	],
	"./components/Logo.bs.js": [
		8629,
		9
	],
	"./components/Logo.res": [
		8546,
		1,
		8546
	],
	"./components/ProjectItem.bs": [
		2450,
		9
	],
	"./components/ProjectItem.bs.js": [
		2450,
		9
	],
	"./components/ProjectItem.res": [
		3603,
		1,
		3603
	],
	"./components/ProjectItemLoading.bs": [
		8694,
		9
	],
	"./components/ProjectItemLoading.bs.js": [
		8694,
		9
	],
	"./components/ProjectItemLoading.res": [
		3093,
		1,
		3093
	],
	"./components/SmallProjectItem.bs": [
		457,
		9
	],
	"./components/SmallProjectItem.bs.js": [
		457,
		9
	],
	"./components/SmallProjectItem.res": [
		5962,
		1,
		5962
	],
	"./components/Tags.bs": [
		3311,
		9
	],
	"./components/Tags.bs.js": [
		3311,
		9
	],
	"./components/Tags.res": [
		344,
		1,
		344
	],
	"./components/Theme.bs": [
		615,
		9
	],
	"./components/Theme.bs.js": [
		615,
		9
	],
	"./components/Theme.res": [
		8610,
		1,
		8610
	],
	"./components/Title.bs": [
		594,
		9
	],
	"./components/Title.bs.js": [
		594,
		9
	],
	"./components/Title.res": [
		2775,
		1,
		2775
	],
	"./index": [
		2812,
		9
	],
	"./index.css": [
		9555,
		9,
		2369,
		9555
	],
	"./index.js": [
		2812,
		9
	],
	"./lib/Blog.bs": [
		9037,
		9
	],
	"./lib/Blog.bs.js": [
		9037,
		9
	],
	"./lib/Blog.res": [
		8680,
		1,
		8680
	],
	"./lib/CodeRenderer.bs": [
		4045,
		9
	],
	"./lib/CodeRenderer.bs.js": [
		4045,
		9
	],
	"./lib/CodeRenderer.res": [
		1498,
		1,
		1498
	],
	"./lib/Project.bs": [
		4,
		9
	],
	"./lib/Project.bs.js": [
		4,
		9
	],
	"./lib/Project.res": [
		3439,
		1,
		3439
	],
	"./lib/X.res.stop": [
		1202,
		1,
		1202
	],
	"./pages/AboutMePage.bs": [
		3738,
		9
	],
	"./pages/AboutMePage.bs.js": [
		3738,
		9
	],
	"./pages/AboutMePage.res": [
		7385,
		1,
		7385
	],
	"./pages/ArticlePage.bs": [
		8703,
		9
	],
	"./pages/ArticlePage.bs.js": [
		8703,
		9
	],
	"./pages/ArticlePage.res": [
		9374,
		1,
		9374
	],
	"./pages/BlogPage.bs": [
		7059,
		9
	],
	"./pages/BlogPage.bs.js": [
		7059,
		9
	],
	"./pages/BlogPage.res": [
		6790,
		1,
		6790
	],
	"./pages/Error404Page.bs": [
		7313,
		9
	],
	"./pages/Error404Page.bs.js": [
		7313,
		9
	],
	"./pages/Error404Page.res": [
		3892,
		1,
		3892
	],
	"./pages/ProjectsPage.bs": [
		2673,
		9
	],
	"./pages/ProjectsPage.bs.js": [
		2673,
		9
	],
	"./pages/ProjectsPage.res": [
		9464,
		1,
		9464
	],
	"./styles/blog.css": [
		6782,
		9,
		6782
	],
	"./styles/code.css": [
		5361,
		9,
		5361
	],
	"./styles/code/oneMonokai": [
		7808,
		3
	],
	"./styles/code/oneMonokai.json": [
		7808,
		3
	],
	"./styles/dark.css": [
		590,
		9,
		590
	],
	"./styles/global.css": [
		299,
		9,
		2369,
		299
	],
	"./styles/header.css": [
		6582,
		9,
		4201
	],
	"./styles/projects.css": [
		8224,
		9,
		8224
	],
	"./styles/typography.css": [
		2685,
		9,
		2685
	],
	"./styles/variables.css": [
		9959,
		9,
		9959
	],
	"./styles/vendor/bulma.min.css": [
		6012,
		9,
		6012
	],
	"./wrappers/Browser.bs": [
		9140,
		9
	],
	"./wrappers/Browser.bs.js": [
		9140,
		9
	],
	"./wrappers/Browser.res": [
		5577,
		1,
		5577
	],
	"./wrappers/Fetch.bs": [
		8984,
		9,
		8984
	],
	"./wrappers/Fetch.bs.js": [
		8984,
		9,
		8984
	],
	"./wrappers/Fetch.res": [
		8597,
		1,
		8597
	],
	"./wrappers/ReactDOMClient.bs": [
		366,
		7,
		366
	],
	"./wrappers/ReactDOMClient.bs.js": [
		366,
		7,
		366
	],
	"./wrappers/ReactDOMClient.res": [
		8401,
		1,
		8401
	],
	"./wrappers/ReactMarkdown.bs": [
		1817,
		7,
		4198
	],
	"./wrappers/ReactMarkdown.bs.js": [
		1817,
		7,
		4198
	],
	"./wrappers/ReactMarkdown.res": [
		8207,
		1,
		8207
	],
	"./wrappers/ReactRouterDom.bs": [
		234,
		9
	],
	"./wrappers/ReactRouterDom.bs.js": [
		234,
		9
	],
	"./wrappers/ReactRouterDom.res": [
		9113,
		1,
		9113
	],
	"./wrappers/SyntaxHighlighter.bs": [
		6102,
		7,
		6102
	],
	"./wrappers/SyntaxHighlighter.bs.js": [
		6102,
		7,
		6102
	],
	"./wrappers/SyntaxHighlighter.res": [
		5624,
		1,
		3243
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6759;
module.exports = webpackAsyncContext;